import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
    FormBuilder,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    UserProfile,
    UserProfileService,
} from '@polaris-customerweb/sharedcomponents.user-profile';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { firstValueFrom } from 'rxjs';
import { AnalyticsDirective } from 'src/app/directives/analytics.directive';

@Component({
    imports: [
        AngularSvgIconModule,
        FormsModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        NgClass,
        ReactiveFormsModule,
        AnalyticsDirective,
    ],
    selector: 'rdx-settings',
    standalone: true,
    styleUrls: ['./settings.component.scss'],
    templateUrl: './settings.component.html',
})
export class SettingsComponent implements OnInit {
    profile: UserProfile;
    settingsForm: FormGroup;

    private successString = 'Success';
    private errorString = 'Error';

    constructor(
        private formBuilder: FormBuilder,
        private matDialog: MatDialog,
        private matSnackBar: MatSnackBar,
        private userProfileService: UserProfileService
    ) {
        this.successString = $localize`Success`;
        this.errorString = $localize`Error`;
    }

    async ngOnInit() {
        const userProfile = await firstValueFrom(
            this.userProfileService.getUserProfile$()
        );
        this.profile = userProfile?.clone() || new UserProfile({});
        this.settingsForm = this.formBuilder.group({
            systemOfMeasurement: this.profile.systemOfMeasurement,
        });
    }

    async onSave() {
        if (this.settingsForm.invalid || !this.settingsForm.dirty) {
            return;
        }
        this.profile.systemOfMeasurement =
            this.settingsForm.value.systemOfMeasurement;

        try {
            await firstValueFrom(
                this.userProfileService.updateUserProfile$(this.profile)
            );
            this.matSnackBar.open(this.successString);
        } catch (err) {
            this.matSnackBar.open(this.errorString);
            throw err;
        }

        this.onCancel();
    }

    onCancel() {
        this.matDialog.closeAll();
    }
}
